export const DEFAULT_PREVIOUS_RESIDENCE_MONTHS_AT = 12;
